<template>
  <div style="height: 100%; text-align: center;">
    <div v-if="openLab" style="height: 100%; text-align: center;">
      <LabConversation />
    </div>

    <div v-else style="height: 100%; text-align: center;">
      <v-list-subheader
        v-if="!current_contact.contact_id"
        class="justify-center"
        style="font-weight: bold;"
      >
        Choose a contact to get started
      </v-list-subheader>
      <FDMessenger :allConversations="getAllConversations" :contact="getHeaderDiv" />
    </div>
  </div>
</template>

<script>
import FDMessenger from "@/components/FrontDesk/FDMessenger";
import { mapGetters } from "vuex";
import LabConversation from "./LabConversation.vue";
import EventBus from "../../eventBus";

export default {
  name: "CenterPanel",
  components: { FDMessenger, LabConversation },
  data() {
    return {
      openLab: false, 
    };
  },
  computed: {
    ...mapGetters("frontdesk", ["current_contact", "contactByCall", "callsByContact", "getAllConversations"]),
    ...mapGetters("people", ["getHeaderInfo"]),
    calls: function() {
      return this.callsByContact(this.contactByCall(this.current_contact));
    },
    getHeaderDiv: function() {
      return this.getHeaderInfo(this.current_contact.contact_id)
    },
  },
  mounted() {
      EventBus.$on("openlab_conversation", (value) => {
    this.openLab = value;  
    console.log("LabConversation status:", value);
  });
  },
  beforeUnmount() {
    EventBus.$off("openlab_conversation");
  },
};
</script>

<style scoped>
.chat-bubble-container {
  white-space: pre-wrap;
  display: flex;
}

.chat-bubble {
  text-align: left;
  font-size: 0.9rem;
  padding: 0.4rem 0.5rem;
  border-radius: 0.5rem;
  width: auto;
  max-width: 80%;
}

.msg-center {
  background-color: #f5f5f5;
  align-items: center;
  align-content: center;
  align-self: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
